import React, { useState } from 'react';
import LaboratoryList from '../LaboratoryList/LaboratoryList';
import LaboratoryRequestList from '../LaboratoryRequestsList/LaboratoryRequestsList';
import LaboratoryRequestCreateWizard from '../LaboratoryRequestCreateWizard/LaboratoryRequestCreateWizard';
import { Laboratory } from '../../../../graphql/graphql';

interface Props {
	patientId: string;
	workplaceId: string;
	onRequestCreate: () => void;
	onRequestSelect?: () => void;
}

enum LaboratoryRequestCreateStatus {
	LABORATORY_SELECTION = 'laboratory_selection',
	REQUEST_SELECTION = 'request_selection',
	FORM_FILL = 'form_fill',
}

const LaboratoryRequestCreate: React.FC<Props> = ({
	patientId,
	onRequestCreate,
	onRequestSelect,
	workplaceId,
}) => {
	const [state, setState] = useState<LaboratoryRequestCreateStatus>(
		LaboratoryRequestCreateStatus.LABORATORY_SELECTION,
	);
	const [selectedLaboratoryCode, setSelectedLaboratoryCode] = useState<
		string | undefined
	>(undefined);
	const [selectedLaboratoryId, setSelectedLaboratoryId] = useState<
		string | undefined
	>(undefined);
	const [selectedFormId, setSelectedFormId] = useState<string | undefined>(
		undefined,
	);

	const selectLaboratory = (laboratory: Laboratory) => {
		setSelectedLaboratoryId(laboratory.id);
		setSelectedLaboratoryCode(laboratory.code);
		setState(LaboratoryRequestCreateStatus.REQUEST_SELECTION);
	};

	const selectRequest = (wizardId: string) => {
		setSelectedFormId(wizardId);
		setState(LaboratoryRequestCreateStatus.FORM_FILL);
		onRequestSelect?.();
	};

	switch (state) {
		case LaboratoryRequestCreateStatus.LABORATORY_SELECTION:
			return <LaboratoryList onClick={selectLaboratory} />;
		case LaboratoryRequestCreateStatus.REQUEST_SELECTION:
			if (selectedLaboratoryId) {
				return (
					<LaboratoryRequestList
						laboratoryId={selectedLaboratoryId}
						onClick={selectRequest}
					/>
				);
			}
			break;
		case LaboratoryRequestCreateStatus.FORM_FILL:
			if (selectedFormId && selectedLaboratoryCode) {
				return (
					<LaboratoryRequestCreateWizard
						onCreate={onRequestCreate}
						formId={selectedFormId}
						patientId={patientId}
						workplaceId={workplaceId}
						laboratoryCode={selectedLaboratoryCode}
					/>
				);
			}
			break;
	}

	return <></>;
};

export default LaboratoryRequestCreate;
